module.exports = __webpack_public_path__ + "assets/ic-discord.6f7d218a.svg";